import { createSlice } from "@reduxjs/toolkit";
import { fetchDoctorAppointmentsReducer } from "../../reducer/appointments/fetchDoctorAppointmentsReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
  isLoading: false,
  error: null,
};

const doctorAppointmentsSlice = createSlice({
  name: "doctorAppointments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorAppointmentsReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDoctorAppointmentsReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.appointments || action.payload || [];
        state.total = action.payload?.pagination?.total || action.payload?.total || 0;
        state.page = action.payload?.pagination?.page || action.payload?.page || 1;
        state.limit = action.payload?.pagination?.limit || action.payload?.limit || 10;
        state.totalPages = action.payload?.pagination?.total_pages || 
          (state.total > 0 && state.limit > 0 ? Math.ceil(state.total / state.limit) : 1);
      })
      .addCase(fetchDoctorAppointmentsReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload || i18n.t("toast.failedToLoadDoctorAppointments");
      });
  },
});

export default doctorAppointmentsSlice.reducer;
